module.exports = __webpack_public_path__ + "static/img/peopleGame2.4802714.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/peopleGame2.png
// module id = HApk
// module chunks = 3